import { DatePicker } from 'antd';
import { RangePickerProps } from 'antd/es/date-picker';

const { RangePicker } = DatePicker;

const RangePickerForm = (props: RangePickerProps) => {
  return (
    <RangePicker
      size="large"
      style={{
        width: '100%',
      }}
      {...props}
    />
  );
};

export default RangePickerForm;
